import axios from "axios";
import {API_URL} from "../constants";
import {authHeader} from "../Utilities";
import {StringWithAutocomplete} from "../UtilitiesTs";


export interface AwsCredKeys {
    aws_access_key_id: string,
    aws_secret_access_key: string,
}

export interface AwsCredProfile {
    aws_profile: StringWithAutocomplete<"IMPORT_S3">,
}

export type Bucket = {bucket: string} | {bucket_alias: StringWithAutocomplete<"IMPORT_S3">};

export type AwsCredentials = AwsCredKeys | AwsCredProfile;

export interface BucketItem {
    s3_key: string,
    size: number,
    type: "file",
    upload_date: string,
}

class AmazonS3Service {
    async getBucketContentRecursive(bucket: Bucket, cred: AwsCredentials): Promise<BucketItem[]> {
        const params: any = {
            ...cred,
            ...bucket,
        };
        const response = await axios.get<BucketItem[]>(
            API_URL + `/s3/bucket_content`,
            {params, headers: authHeader()}
        );
        return response.data;
    }
}

export default new AmazonS3Service();